/* [PATCH pn-23 v1] Vloga uporabnika v Potnih nalogih / Delovnem času za IZBRANO podjetje — ista odločitev kot backend
   (GET /kadri/{cid}/moja-vloga: admin | zaposleni). Meni se ravna po njej, ne po predpomnjeni zastavici upravlja_aplikacije.
   Kliče se samo na straneh teh dveh aplikacij. */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from './api';
import { useAuthStore } from '../stores/authStore';

const POTI = ['/potni-nalogi', '/kadri', '/pn-sifranti', '/vozila', '/nameni-poti', '/moj-mesec', '/dc-pregled', '/pn-prenos', '/dc-skupina']; // [PATCH dc2 v1] [PATCH dc-pregled v1] [PATCH pn-prenos-kn21 v1] [PATCH dc-skupina-fe v1]

export function usePnVloga(): string | null {
  const { selectedCompany } = useAuthStore();
  const cid = (selectedCompany as any)?.id as string | undefined;
  const { pathname } = useLocation();
  const aktivno = POTI.some(p => pathname === p || pathname.startsWith(p + '/'));
  const [vloga, setVloga] = useState<string | null>(null);
  useEffect(() => {
    if (!aktivno || !cid) { setVloga(null); return; }
    let ziv = true;
    api.get(`/kadri/${cid}/moja-vloga`).then(r => { if (ziv) setVloga(r.data.vloga); }).catch(() => { if (ziv) setVloga(null); });
    return () => { ziv = false; };
  }, [aktivno, cid]);
  return vloga;
}
